import { render, staticRenderFns } from "./numberInput.vue?vue&type=template&id=2218dd60&scoped=true&"
import script from "./numberInput.vue?vue&type=script&lang=js&"
export * from "./numberInput.vue?vue&type=script&lang=js&"
import style0 from "./numberInput.vue?vue&type=style&index=0&id=2218dd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218dd60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2218dd60')) {
      api.createRecord('2218dd60', component.options)
    } else {
      api.reload('2218dd60', component.options)
    }
    module.hot.accept("./numberInput.vue?vue&type=template&id=2218dd60&scoped=true&", function () {
      api.rerender('2218dd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/numberInput.vue"
export default component.exports